import api from "../../api";
import { Title, Breadcrumbs, PreLoader, ConferenceCardList, ConferenceCard } from "../../components";
import styles from "./style.module.css";
import { useState, useEffect } from "react";

const ConferencesList = () => {
    const [loading, setLoading] = useState(false);
    const [conferences, setConferences] = useState([])
    useEffect(() => {
        setLoading(true);
        api.getConferences()
            .then((data) => {
                setLoading(false);
                setConferences(data);
            })
            .catch((err) => {
                console.log(err.message);
            });
    }, []);
    const titleName = 'Отчеты о конференциях'
    return (
        <>
            {loading ? (
                <PreLoader />
            ) : (
                <>
                    <Title title={titleName} />
                    <div className={styles.conferences_area}>
                        <Breadcrumbs urls={[{ title: titleName, path: '' }]} />
                        <ConferenceCardList>
                            {conferences.results?.map((card) => <ConferenceCard
                                {...card}
                                key={card.id}
                            />)}
                        </ConferenceCardList>
                    </div>
                </>
            )}
        </>
    );
}

export default ConferencesList;